formatCaptureEmailData